import { useMemo } from "react";

import { API_URLS } from "shared/constants";
import useHttpActions from "shared/services/api/core/useHttpActions";

import BaseConverter from "./converters/baseConverter";

import type { BonusTypes, ListBonusesResult } from "../types/BonusModel";

const useBonusApiService = () => {
	const actions = useHttpActions();

	return useMemo(
		() => ({
			list: async (params: { type?: BonusTypes; dateFrom?: string; dateTo?: string }) => {
				return BaseConverter.convert<ListBonusesResult>(
					await actions.get(
						API_URLS.BONUSES.LIST,
						params
						// {
						// 	resolvers: [
						// 		{
						// 			fields: ["data"],
						// 			resolver: bonusResolver
						// 		}
						// 	]
						// }
					)
				);
			}
		}),
		[actions]
	);
};

export default useBonusApiService;
